import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Why Do Businesses Need Magento for{" "}
              <span>Ecommerce Website Development?</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              Choose Magento for your e-commerce website development for its
              versatile features and adaptability.As a leading Magento
              development company, we harness its scalability and robust toolset
              to create tailored solutions.Its SEO-friendly nature, security
              features, and strong community support make it a reliable choice
              for powerful and customized online stores.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Seamless Integration</h6>
                <p>
                  Seamlessly integrate tools and extensions for a unified and
                  streamlined ecommerce infrastructure.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Scalability</h6>
                <p>
                  Capacity for growth without compromising performance or user
                  experience, ensuring adaptability.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Diverse Product Management</h6>
                <p>
                  Magento offers flexibility by enabling developers to tailor
                  the platform to specific business requirements.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Effortless APIs Integration</h6>
                <p>
                  Adaptable interfaces enable smooth API integration with
                  diverse systems and applications for functionality.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
